import type { FormikHelpers } from "formik";
import React from "react";
import { EmailField } from "./EmailField";
import PasswordEntry from "../../PasswordEntry";

// Re-exported for backwards compatibility with PasswordResetForm /
// GuestSignup, which currently import these names from this module. The
// canonical definitions now live alongside PasswordEntry, which
// self-validates via Formik field-level validators — new callers should
// not need to wire the schemas into their own validationSchema at all.
export {
  createPasswordSchema,
  passwordConfirmationSchema,
} from "../../PasswordEntry/PasswordEntry";

interface UsernamePasswordProps {
  emailDataTestid: string;
  isSignUp?: boolean;
  passwordConfirmationDataTestid?: string;
  passwordDataTestid?: string;
  setFieldValue?: FormikHelpers<any>["setFieldValue"];
}

/**
 * UsernamePassword renders the email + password (and optional confirm)
 * fields. Validation is handled inside the child controls; the parent
 * Formik only needs to declare email/password as required at the top
 * level if it cares about the submit-blocking gate.
 */
const UsernamePassword: React.FC<UsernamePasswordProps> = ({
  setFieldValue,
  emailDataTestid,
  passwordDataTestid,
  passwordConfirmationDataTestid,
  isSignUp = false,
}) => {
  return (
    <>
      <EmailField
        emailDataTestid={emailDataTestid}
        setFieldValue={setFieldValue}
      />

      <PasswordEntry
        passwordConfirmationDataTestid={passwordConfirmationDataTestid}
        passwordDataTestid={passwordDataTestid}
        showConfirmPassword={isSignUp}
      />
    </>
  );
};

export default UsernamePassword;
